import Icon from '../../components/Icon.vue'

Icon.register({"regular/user":{"width":512,"height":512,"paths":[{"d":"M423.3 291L402.2 285C431.8 243.9 436 202.3 436 180 436 80.6 355.5 0 256 0 156.6 0 76 80.5 76 180 76 202.3 80.2 243.9 109.8 285L88.7 291C21.3 310.3 0 371.6 0 408.6V434.3C0 477.1 34.9 512 77.7 512H434.3C477.1 512 512 477.1 512 434.3V408.6C512 372.4 491.3 310.4 423.3 291zM256 48C328.9 48 388 107.1 388 180S328.9 312 256 312 124 252.9 124 180 183.1 48 256 48zM464 434.3C464 450.7 450.7 464 434.3 464H77.7C61.3 464 48 450.7 48 434.3V408.6C48 375.4 70 346.3 101.9 337.2L148 324C162.7 335.1 200.4 360 256 360S349.3 335.1 364 324L410.1 337.2C442 346.3 464 375.4 464 408.6V434.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/user.js
// module id = null
// module chunks = 